import React from 'react'
import { Box, Collapse, Grid, Paper, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { Check, Close } from '@mui/icons-material'
import FlatTextField from '@components/FlatTextField'
import { useHelpArticleFeedback } from '@api/helpCenter'
import { toast } from 'react-toastify'
import FlatButton from '@components/FlatButton'
import ResponsiveButton from '@components/ResponsiveButton'

function ArticleUseful({ id }) {
  const { t } = useTranslation(['common', 'help-center'])
  const [open, setOpen] = React.useState(false)
  const [feedback, setFeedback] = React.useState('')
  const [submitting, setSubmitting] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)
  const feedbackMutation = useHelpArticleFeedback()
  const handleSubmit = () => {
    if (open) {
      setSubmitting(true)
      feedbackMutation
        .mutateAsync({
          feedback,
          article_id: id,
          is_useful: open === 'yes',
        })
        .then(() => setSubmitted(true))
        .catch(() => toast.error('Failed to save your feedback'))
        .finally(() => setSubmitting(false))
    }
  }
  React.useEffect(() => {
    setOpen(false)
    setFeedback('')
    setSubmitting(false)
    setSubmitted(false)
  }, [id])
  return (
    <Paper sx={{ borderRadius: 2, mt: 14 }}>
      <Box p={5}>
        {!submitted && (
          <Grid
            container
            spacing={2}
            justifyContent="center"
          >
            <Grid
              item
              xs={12}
            >
              <Typography
                variant="body1"
                textTransform="capitalize"
                textAlign="center"
                display="block"
              >
                {t('help-center:is_this_article_was_useful')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Grid
                container
                spacing={2}
                justifyContent="center"
              >
                <Grid item>
                  <ResponsiveButton
                    color="primary"
                    startIcon={<Check sx={{ transform: 'scaleX(1)!important' }} />}
                    onClick={() => setOpen('yes')}
                    disableElevation
                    variant={open === 'yes' ? 'contained' : 'text'}
                  >
                    {t('common:yes')}
                  </ResponsiveButton>
                </Grid>
                <Grid item>
                  <ResponsiveButton
                    color="error"
                    startIcon={<Close />}
                    onClick={() => setOpen('no')}
                    disableElevation
                    variant={open === 'no' ? 'contained' : 'text'}
                  >
                    {t('common:no')}
                  </ResponsiveButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Collapse in={open}>
                <Box>
                  <FlatTextField
                    backgroundColor="#F3F5F7"
                    fullWidth
                    placeholder={`${t('help-center:Your_feedback')} (${t('common:optional')})`}
                    multiline
                    rows={3}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                  <Box
                    mt={2}
                    sx={{ textAlign: 'right' }}
                  >
                    <FlatButton
                      variant="contained"
                      disableElevation
                      isLoading={submitting}
                      onClick={handleSubmit}
                    >
                      {t('common:submit')}
                    </FlatButton>
                  </Box>
                </Box>
              </Collapse>
            </Grid>
          </Grid>
        )}
        {!!submitted && (
          <Typography
            textAlign="center"
            display="block"
          >
            {t('help-center:Thank_you_for_your_feedback')}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default ArticleUseful
